import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Eingabe } from "../me/index.js";
import "./Feld.css";
/** `typ` der Hülle → `art`/`mehrzeilig` des Elements. */
function artVon(typ) {
    switch (typ) {
        case "email": return "email";
        case "tel": return "tel";
        case "date": return "datum";
        case "zahl": return "zahl";
        default: return "text";
    }
}
/**
 * Ein beschriftetes Formularfeld mit zwei GRUNDVERSCHIEDENEN Darstellungen, nicht nur einer
 * abgeblendeten Variante derselben: Im Lesemodus (`bearbeitbar={false}`) steht der Wert als
 * reiner Text da, ganz ohne `<input>`. Ein deaktiviertes Eingabefeld sähe aus wie etwas, das
 * man ändern könnte, wenn man nur wüsste wie — und ein Bildschirmleser läse es trotzdem als
 * Formularfeld vor, obwohl es dort nichts zu tun gibt.
 *
 * Im Bearbeitungsmodus ist `Feld` seit ME-Etappe 3 (Aufgabe 2) eine Hülle über `me-eingabe`:
 * Beschriftung (`beschriftung`), Fehler (`aria-invalid` + `aria-describedby` am inneren Feld),
 * Hilfetext, Zähler, Pflicht und Sperre kommen vom Element — hier wird nichts nachgebaut.
 * Das innere `<input>`/`<textarea>` liegt im Shadow DOM; Tests greifen über die Helfer in
 * `packages/web/test/feld.ts` darauf zu.
 */
export function Feld(p) {
    if (!p.bearbeitbar) {
        const angezeigterWert = p.wert.trim() === "" ? "—" : p.wert;
        return (_jsxs("div", { className: "ki-feld ki-feld--lesen", children: [_jsx("span", { className: "ki-feld__label", children: p.label }), _jsx("span", { className: "ki-feld__wert", children: angezeigterWert })] }));
    }
    // `exactOptionalPropertyTypes`: nur gesetzte Angaben weiterreichen.
    const optional = {};
    if (p.fehler !== undefined)
        optional.fehler = p.fehler;
    if (p.hilfe !== undefined)
        optional.hilfe = p.hilfe;
    if (p.max !== undefined)
        optional.max = p.max;
    if (p.pflicht === true)
        optional.pflicht = true;
    if (p.gesperrt === true)
        optional.gesperrt = true;
    if (p.typ === "mehrzeilig")
        optional.mehrzeilig = true;
    return (_jsx(Eingabe, { id: p.id, name: p.id, beschriftung: p.label, wert: p.wert, art: artVon(p.typ), ...optional, onGeaendert: (d) => p.onChange(d.wert) }));
}
//# sourceMappingURL=Feld.js.map